// extracted by mini-css-extract-plugin
module.exports = {"area":"Item_index_area__1M5et","checkbox":"Item_index_checkbox__2QnEf","img":"Item_index_img__2BUlX","title":"Item_index_title__1Lgsh","price":"Item_index_price__3Micd"};